export const expiringAdmissionHeader = ({ setModalState, isCro }) => [
  /* {
    headerName: 'Sl No.',
    field: 'slNo',
    sortable: true,
  }, */
  {
    headerName: 'Student Name',
    field: 'student_name',
    sortable: true,
    width: 300,
    toolTipGetter: true,
  },
  ...(isCro
    ? []
    : [
        {
          headerName: 'CRO Name',
          field: 'cro_name',
          sortable: true,
          width: 300,
          toolTipGetter: true,
        },
      ]),
  {
    headerName: 'Course',
    field: 'course_name',
    sortable: true,
    width: 300,
    toolTipGetter: true,
  },
  {
    headerName: 'Total Required Sessions',
    field: 'total_required_sessions',
    sortable: true,
    width: 230,
  },
  {
    headerName: 'Total Sessions Completed',
    field: 'total_sessions_completed',
    sortable: true,
    width: 250,
  },
  {
    headerName: 'Sessions Completion %',
    field: 'completion_percentage',
    sortable: true,
    width: 200,
  },
  {
    headerName: 'SRO Sales Amount',
    field: 'sro_sales_amount',
    sortable: true,
    width: 200,
  },
  {
    headerName: 'Total Fee Paid',
    field: 'total_fee_paid',
    sortable: true,
    width: 180,
  },
  {
    headerName: 'Status',
    field: 'expiring_admission_status',
    sortable: true,
    width: 180,
    ...(isCro
      ? {
          renderCell: ({ value, row }) => (
            <p
              style={{
                cursor: 'pointer',
              }}
              onClick={() =>
                setModalState({
                  actionKey: 'Change Status',
                  row,
                })
              }
            >
              {value}
            </p>
          ),
        }
      : []),
  },
  {
    headerName: 'Remarks',
    field: 'expiring_admission_remarks',
    sortable: true,
    width: 250,
    toolTipGetter: true,
  },
];
